import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  standalone: false,
  templateUrl: './countdown-timer.component.html',
  styleUrl: './countdown-timer.component.scss'
})
export class CountdownTimerComponent {
  @Input() type: 'start' | 'end' = 'start';
  @Input() timestamp!: string | number | Date;

  prefixText: string = '';
  timerText: string = '';

  private timerSubscription!: Subscription;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.updateCountdown();
    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateCountdown();
      this.cdr.detectChanges();
    });
    this.prefixText = `${this.type === 'start' ? 'Starts In' : 'Ends In'}`;
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private updateCountdown(): void {
    const now = new Date().getTime();
    const targetTime = new Date(this.timestamp).getTime();
    const diff = targetTime - now;

    if (diff <= 0) {
      this.timerText = 'Overdue';
      return;
    }

    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    this.timerText = `${days}:${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  private pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
}
